import Addresses from "../_ApiConn/apiAddresses";


const getAddressesByCity = async (obj) => {
    let dFromF = await Addresses.getAddressesByCity(obj);
    return (dFromF);
}

const getStreetsWithZoneByCity = async (cityName) => {
    let dFromF = await Addresses.getStreetsWithZoneByCity(cityName);
    return (dFromF);
}



export default {
    getAddressesByCity,
    getStreetsWithZoneByCity
};